function getFirstCharacter(string) {
  return string.charAt(0);
}

function formatSender(sender) {

  sender.displayName = sender.fullName || sender.fromName || sender.fromEmailAddress || sender.email || '';
  sender.initials = sender.displayName.split(' ').map(getFirstCharacter).join('');

  return sender;

}

function createMessageGroup(conversation, message) {

  let sender = message.sender;

  const messageGroup = {
    _id: message._id,
    sender: formatSender(sender),
    messages: [message],
    type: message.type,
    conversation
  };

  return messageGroup;

}

export function appendMessage(messageGroups, message, conversation) {

  const messageGroupsLength = messageGroups.length;

  if (messageGroupsLength === 0) {
    messageGroups.push(createMessageGroup(conversation, message));
    return;
  }

  const lastMessageGroup = messageGroups[messageGroupsLength - 1];

  if (lastMessageGroup.type === message.type) {
    lastMessageGroup.messages.push(message);
  } else {
    messageGroups.push(createMessageGroup(conversation, message));
  }

}

function groupMessages(messages, conversation) {

  const messageGroups = [];

  for (let message of messages) {

    appendMessage(messageGroups, message, conversation);

  }

  return messageGroups;

}

function mergeMessageGroups(messageGroupsOne, messageGroupsTwo) {

  const messageGroupsOneLength = messageGroupsOne.length;

  if (messageGroupsOneLength === 0) {
    messageGroupsOne.push(...messageGroupsTwo);
    return messageGroupsOne;
  }

  const messageGroupsTwoLength = messageGroupsTwo.length;

  if (messageGroupsTwoLength === 0) {
    return messageGroupsOne;
  }

  const messageGroupsOneLastEntry = messageGroupsOne[messageGroupsOneLength - 1];
  const messageGroupsTwoFirstEntry = messageGroupsTwo[0];

  if (messageGroupsOneLastEntry.type === messageGroupsTwoFirstEntry.type) {

    messageGroupsOneLastEntry.messages.push(...messageGroupsTwoFirstEntry.messages);

    messageGroupsOne.push(...messageGroupsTwo.slice(1));

  } else {

    messageGroupsOne.push(...messageGroupsTwo);

  }

  return messageGroupsOne;

}

export function prependMessages(messageGroups, messages, conversation) {

  if (messages.length === 0) {
    return messageGroups;
  }

  const newMessageGroups = groupMessages(messages, conversation);

  return mergeMessageGroups(newMessageGroups, messageGroups);

}

export function isMessageExistsById(messageGroups, messageId) {

  for (let messageGroup of messageGroups) {

    for (let message of messageGroup.messages) {

      if (message._id === messageId) {
        return true;
      }

    }

  }

  return false;

}

export function findMessageLocation(messageGroups, messageId) {

  for (var groupIndex = 0; groupIndex < messageGroups.length; groupIndex++) {

    var messages = messageGroups[groupIndex].messages;

    for (var messageIndex = 0; messageIndex < messages.length; messageIndex++) {

      if (messages[messageIndex]._id === messageId) {
        return { groupIndex, messageIndex };
      }

    }

  }

  return null;

}

export function findMessageById(messageGroups, messageId) {

  const location = findMessageLocation(messageGroups, messageId);

  if (location === null) {
    return null;
  }

  return messageGroups[location.groupIndex].messages[location.messageIndex];

}

export function updateMessage(messageGroups, message) {

  var location = findMessageLocation(messageGroups, message._id);

  if (location === null) {
    return false;
  }

  var existingMessage = messageGroups[location.groupIndex].messages[location.messageIndex];

  if ((existingMessage.updatedAt || 0) >= message.updatedAt) {
    return false;
  }

  messageGroups[location.groupIndex].messages[location.messageIndex] = { ...existingMessage, ...message };

  return location;

}

export function isExternalMessageExistsById(messageGroups, messageId) {

  for (let messageGroup of messageGroups) {

    for (let message of messageGroup.messages) {

      if (message.channelMetadata.messageId.external === messageId) {
        return true;
      }

    }

  }

  return false;

}

export function findMessageByExternalId(messageGroups, messageId) {

  for (let messageGroup of messageGroups) {

    for (let message of messageGroup.messages) {

      if (message.channelMetadata.messageId.external === messageId) {
        return message;
      }

    }

  }

  return null;

}

export function isAudioMime(mime) {

  const audioMimeTypes = [
    'audio/x-wav', 'audio/mpeg', 'audio/mp4', 'audio/mpeg',
    'application/ogg', 'audio/webm', 'audio/wav', 'audio/vnd.wave'
  ];

  return audioMimeTypes.indexOf(mime) !== -1;

}

export function isVideoMime(mime) {

  const videoMimeTypes = ['video/mpeg', 'video/mp4', 'video/ogg', 'video/quicktime', 'video/webm', 'video/x-msvideo'];

  return videoMimeTypes.indexOf(mime) !== -1;

}

export function isImageMime(mime) {

  const imageMimeTypes = ['image/bmp', 'image/gif', 'image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml', 'image/webp'];

  return imageMimeTypes.indexOf(mime) !== -1;

}

export function setMessageField(conversation, message, field, messageGroups) {

  const messageId = message._id;
  const messageGroupsLength = messageGroups.length;

  // Delivered message might be the latest. 
  // So, iterating groups & messages backwards
  for (let index = messageGroupsLength - 1; index >= 0; index--) {

    const messageGroup = messageGroups[index];

    const messages = messageGroup.messages;

    const messagesLength = messages.length;

    for (let messageIndex = messagesLength - 1; messageIndex >= 0; messageIndex--) {

      const _message = messages[messageIndex];

      if (_message._id === messageId) {
        _message[field] = message[field];
        return;
      }

    }

  }

}

export function setMessageAsDelivered(conversation, message, messageGroups) {

  return setMessageField(conversation, message, 'deliveredAt', messageGroups);

}

export function setMessageAsViewed(conversation, message, messageGroups) {

  return setMessageField(conversation, message, 'viewedAt', messageGroups);

}

export function buildMessageList(messageGroups) {

  var messages = [];

  for (var i = 0; i < messageGroups.length; i++) {
    var group = messageGroups[i];
    for (var j = 0; j < group.messages.length; j++) {
      messages.push(group.messages[j]);
    }
  }

  return messages;

}

export function removeMessage(messageGroups, messageId) {

  const messageGroupsLength = messageGroups.length;

  for (let groupIndex = messageGroupsLength - 1; groupIndex >= 0; groupIndex--) {

    const messageGroup = messageGroups[groupIndex];
    const messages = messageGroup.messages;
    const messagesLength = messages.length;

    for (let messageIndex = messagesLength - 1; messageIndex >= 0; messageIndex--) {

      if (messages[messageIndex]._id === messageId) {
        messages.splice(messageIndex, 1);
      }

    }

    if (messages.length === 0) {
      messageGroups.splice(groupIndex, 1);
    }

  }

}